import React from "react";
import classes from "./AHFCompletedBanner.scss";
import { Button, Alert } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

const TEST_ID_PREFIX = "projects-ahfCompletedBanner";

const AHFCompletedBanner = props => {
  const { title, onButtonClick, disabled = false } = props;
  const { t } = useI18n(["common"]);
  return (
    <div className={classes.container}>
      <Alert
        type={"success"}
        title={title}
        actionElement={
          !disabled ? (
            <Button
              type="inline"
              variant="destructive"
              onClick={onButtonClick}
              testId={`${TEST_ID_PREFIX}-unmarkAsComplete`}
            >
              {t("common:unmark_as_complete")}
            </Button>
          ) : null
        }
      />
    </div>
  );
};

export default AHFCompletedBanner;
